<template>
    <div>
        <div class="modal-backdrop-si" @click="cancel">
            <div id="jjModal" class="modal-si" tabindex="-1" role="dialog" ref="jjModal">
                <div class="modal-dialog-si" role="document">
                    <div class="modal-content-si">
                        <div class="modal-title" style="margin-bottom:20px;">
                            <h3>{{header}}</h3>
                            <div class="close-modal" @click="cancel">
                                <font-awesome-icon icon="times"  aria-hidden="false" />
                            </div>

                        </div>
                        <div v-if="modalType == modalTypes.pcRequirements">
                            <div class="sub-section-content">
                                <b>SYSTEM REQUIREMENTS</b><br>
                                <ul>
                                    <li>Operating System: Windows 8 minimum</li>
                                    <li>Memory: 2GB RAM</li>
                                    <li>Processor: 1 Ghz AMD, Intel or equivalent CPU</li>
                                    <li>Hard Drive: 10 to 15 GB Free Hard Drive Space for Music Downloads</li>
                                    <li>Sound Card: Direct X Compatible</li>
                                    <li>Display: Resolution of 1024 x 768 or better</li>
                                    <li>Internet connection: LAN or Wireless</li>
                                </ul>

                                <b>HOST PC CONFIGURATION</b><br>
                                <i>Prior to installing the software, apply all of the below applicable Windows settings:</i>

                                <ul>
                                    <li>Install all latest Windows Updates, ensuring all Microsoft .NET Framework updates are installed</li>
                                    <li>Turn off Screen Saver and change Power Options to 'Always On' or 'High Performance'</li>
                                    <li>Turn off all Windows Sounds</li>
                                    <li>Ensure any Anti-Virus or security software is set to 'Allow' DownloadPlayer.exe</li>
                                </ul>
                            </div>
                        </div>

                        <div v-if="modalType == modalTypes.installation">
                            <div class="sub-section-content">
                                <b>OVERVIEW</b><br>
                                <p>
                                    The TPG Player is a software music application that runs on a Windows host PC. The system automatically delivers custom playlists from our high quality licensed audio library, receiving updates and programming changes via the Internet. The TPG Player
                                    features a built-in audio compressor to normalize volume, adjustable cross-fade and Windows audio integration. You can access the software installer via direct download. Once installed, the TPG Player will do the rest.
                                </p>

                                <b>SYSTEM REQUIREMENTS</b><br>
                                <ul>
                                    <li>Operating System: Windows 8 minimum</li>
                                    <li>Memory: 2GB RAM</li>
                                    <li>Processor: 1 Ghz AMD, Intel or equivalent CPU</li>
                                    <li>Hard Drive: 10 to 15 GB Free Hard Drive Space for Music Downloads</li>
                                    <li>Sound Card: Direct X Compatible</li>
                                    <li>Display: Resolution of 1024 x 768 or better</li>
                                    <li>Internet connection: LAN or Wireless</li>
                                </ul>

                                <b>HOST PC CONFIGURATION</b><br>
                                <b>Prior to installing the software, apply all of the below applicable Windows settings:</b><br>
                                <ul>
                                    <li>Install all latest Windows Updates, ensuring all Microsoft .NET Framework updates are installed</li>
                                    <li>Turn off Screen Saver and change Power Options to ‘Always On’ or ‘High Performance’</li>
                                    <li>Turn off all Windows Sounds</li>
                                    <li>Ensure any Anti-Virus or security software is set to ‘Allow’ DownloadPlayer.exe</li>
                                </ul>

                                <b>SOFTWARE DOWNLOAD and INSTALLATION</b><br>
                                <ul>
                                    <li>Download the installer from the provided link</li>
                                    <li>Run the Installer, accepting the terms of the License Agreement</li>
                                    <li>When prompted, enter the License Key for your system as received</li>
                                    <li>Once the application is loaded and running, it will automatically begin downloading the tracks and playlist schedule</li>
                                    <li><b>Music will begin to play automatically once 10% of the music collection has been downloaded.</b></li>
                                </ul>
                                You can check on download progress in the Channel Playlist screen 1LP-DOWNLOAD PLAYER<br><br>

                                <b>TPG PLAYER BASIC SETTINGS</b><br>
                                <ul>
                                    <li>Ensure the PC is connected to AC power and internet (LAN or Wireless)</li>
                                    <li>Connect the PC’s audio output to the amplifier</li>
                                    <li>Click on the ‘Wrench’ icon to display the ‘Options’ panel</li>
                                    <li>AUDIO OPTIONS - the system automatically selects and uses the default sound device as chosen in the Windows Control Panel.</li>
                                    <li>ADVANCED OPTIONS - by default not all of the sections are visible. At the bottom left of the ‘Options’ panel tick the Show Advanced Options box.</li>
                                    <li>WINDOWS OPTIONS - tick “Start this application when Windows Starts” - the TPG Player will now load automatically when Windows starts.</li>
                                </ul>
                            </div>
                        </div>
                        <div v-if="modalType == modalTypes.troubleshooting">
                            <div class="sub-section-content">
                                <b>TROUBLESHOOTING ACTIONS</b><br>
                                <i>If the Music Player fails to start correctly, please check the following:</i>
                                <ul>
                                    <li>You can successfully browse to: theplaylistgeneration.com/jimmyjohns</li>
                                    <li>The time and date on the PC are correct.</li>
                                    <li>The PC hardware has not changed and that you only have 1 active network connection.</li>
                                    <li>The user account the Music Player is running under is 'administrator' or the user has full administrative rights.</li>
                                    <li>Windows firewall is switched off (or the firewall is switched on but the Music Player has an exception).</li>
                                    <li>Windows User Account Control (UAC) is turned off completely (Windows Vista / 7 only).</li>
                                    <li>If a proxy server is being used on the network, the correct details are entered in the proxy settings.</li>
                                    <li>If a hardware firewall is being used on the network, this should be configured to allow the Music Player Internet access.</li>
                                </ul>
                                <div>
                                    If the above actions do not remedy the issue, please contact: <a href="mailto:JJSUPPORT@THEPLAYLISTGENERATION.COM">jjsupport@theplaylistgeneration.com</a>, or contact the Jimmy Tunes Support Line at: <a href="tel:3232759364">323-275-9364</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
  props: ['modalTypes', 'modalType'],
  data() {
    return {
      header: 'Jimmy Tunes',
    };
  },
  mounted() {},
  methods: {
    cancel() {
      this.$emit('close');
    },
    setHeader() {
      if (!this.modalType) return;
      if (this.modalType == this.modalTypes.pcRequirements) {
        this.header = 'PC REQUIREMENTS';
      } else if (this.modalType == this.modalTypes.troubleshooting) {
        this.header = 'Troubleshooting';
      } else if (this.modalType == this.modalTypes.installation) {
        this.header = 'Installation';
      }
    },
  },
  watch: {
    modalType() {
      this.setHeader();
    },
  },
};
</script>

<style scoped>
.modal-backdrop-si {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
}

.modal-si {
    background: #FFFFFF;
    overflow-x: auto;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
    overflow-y: auto;
    border-radius: 5px;
    max-height:500px
}
.modal-content-si {
  -webkit-flex: 0 1 auto;
  -moz-flex: 0 1 auto;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
}
.modal-body-si {
    position: relative;
    padding: 20px 10px;
}

.btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
}

.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease;
}

h3,
a,
a:hover {
    color: rgb(224, 0, 43);
}

.modal-dialog-si {
  position: relative;
  width: auto;
  margin: 10px;
}

ul {
    text-align: left;
}

.modal-content-si {
    width: auto;
    max-width: 700px;
    margin: 0 auto;
    background: #fff;
    color: black;
    padding: 10px;
    padding-bottom: 20px;
    ;
}

.onboarding-container {
    text-align: left;
}

.close-modal {
    color: black;
}

ul {
    margin-bottom: 20px;
}
.noscroll { overflow: hidden; }

@media (min-device-width: 1025px) {
    /* not strictly necessary, just an experiment for
       this specific example and couldn't be necessary
       at all on some browser */
    .noscroll {
        padding-right: 15px;
    }
}

.overlay {
     position: fixed;
     overflow-y: scroll;
     top: 0; left: 0; right: 0; bottom: 0;
}

[aria-hidden="true"] {
    transition: opacity 1s, z-index 0s 1s;
    width: 100vw;
    z-index: -1;
    opacity: 0;
}

[aria-hidden="false"] {
    transition: opacity 1s;
    width: 100%;
    z-index: 1;
    opacity: 1;
}
.close-modal {
  position: absolute;
  top: -10px;
  right: 0px;
  cursor: pointer;
  text-align: right;
  color: black;
  width:20px;
  height:20px;
}

</style>
